export const PHONE = "+36308929102";
export const PHONE_DISPLAY = "+36 30 892 9102";

export const SERVICES = [
  {
    id: "hitel",
    name: "Hitel",
    tag: "Lakáshitel & Jelzáloghitel",
    desc: "Piaci ajánlatok teljes körű összehasonlítása, a legkedvezőbb kamatozású konstrukció megtalálása az Ön élethelyzetéhez.",
    conditions: [
      "Életkori feltétel: Az ügyletben szerepelnie kell legalább egy olyan adósnak vagy adóstársnak, aki a hitel futamideje alatt nem tölti be a 75. életévét, és a futamidő lejárta előtt az igénylők nem tölthetik be a 90. életévüket.",
      "Jövedelemvizsgálat: Legalább a nettó minimálbérnek megfelelő igazolt jövedelem szükséges.",
      "Munkaviszony: Általában minimum 3 hónapos, határozatlan idejű, próbaidőn túli munkaviszony elvárt (határozott idejű vagy külföldi jövedelem esetén szigorúbb, egyedi banki feltételek érvényesek).",
      "Fedezetvizsgálat: Az ingatlan forgalmi értéke elérheti a banki minimumot (banktól függően 4–10 millió Ft), és a forgalmi érték, valamint a vételár közül mindig az alacsonyabbat veszik figyelembe.",
    ],
  },
  {
    id: "biztositas",
    name: "Biztosítás",
    tag: "Élet-, Vagyon- & Gépjármű",
    desc: "Személyre szabott védelem otthonára, családjára és értékeire, átlátható díjakkal és gyors kárrendezéssel.",
    conditions: [
      "Magánszemélyek és cégek számára egyaránt.",
      "Élet / Baleset / Egészségbiztosítások: Személyre szabott ajánlat, hogy csak azért fizessen, amire szüksége van, és a védelem megfelelő mértékű legyen.",
      "Megtakarítások: Nyugdíj, gyermekjövő és egyéb célra — rendszeres díjas és egyösszegű megoldások.",
      "Vagyonbiztosítás: Ingatlan, Casco, telephely, árukészlet — minden, ami nem emberi élet.",
      "Felelősségbiztosítás: KGFB, szakmai felelősség.",
    ],
  },
  {
    id: "csok",
    name: "CSOK",
    tag: "Családi Otthonteremtési Kedvezmény & CSOK Plusz",
    desc: "Otthonteremtési kedvezmény igénylése lakásvásárláshoz és építkezéshez, teljes ügyintézéssel.",
    conditions: [
      "Jogosultsági feltételek: Meglévő vagy vállalt gyermekek száma, érvényes házastársi jogviszony, valamint a feleség életkori korlátja (pl. CSOK Plusz esetén 41 év alatti kor).",
      "TB jogviszony: Szigorú társadalombiztosítási jogviszonyra vonatkozó elvárás (formától függően 1 vagy 2 év folyamatos TB jogviszony).",
      "Büntetlen előélet és köztartozásmentesség (NAV-tartozás hiánya).",
    ],
  },
  {
    id: "otthonstart",
    name: "Otthonstart",
    tag: "Első Lakás Program",
    desc: "Kedvezményes, fix kamatozású hitel az első otthon megszerzéséhez — végigkísérjük a teljes folyamaton.",
    conditions: [
      "Célcsoport: Kizárólag első lakásukat vásárló, fiatal magánszemélyek vagy fiatal házaspárok számára elérhető.",
      "Tulajdoni korlát: Az igénylőnek korábban nem lehetett lakástulajdona (vagy csak a jogszabályban megengedett minimális kivétellel).",
      "Finanszírozás: Kedvezményes, fix kamatozású konstrukció saját erő és megfelelő jövedelemfedezet mellett.",
    ],
  },
  {
    id: "babavaro",
    name: "Babaváró",
    tag: "Babaváró Támogatás",
    desc: "Szabad felhasználású, kamatmentes kölcsön fiatal házaspároknak — feltételek felmérése és igénylés egy helyen.",
    conditions: [
      "Életkori feltétel: A feleségnek a szerződéskötéskor be kell töltenie a 18. életévét, de még nem töltheti be a 35. életévét (átmeneti szabályok vagy várandósság igazolása esetén a határ magasabb is lehet).",
      "Házastársi státusz: Érvényes házasság és mindkét fél részéről magyarországi lakóhely szükséges.",
      "TB jogviszony: Legalább 3 éves folyamatos társadalombiztosítási jogviszony igazolása kötelező.",
    ],
  },
  {
    id: "szemelyi",
    name: "Személyi kölcsön",
    tag: "Szabad felhasználás",
    desc: "Gyors és rugalmas finanszírozás céljaihoz, kiszámítható törlesztéssel és minimális adminisztrációval.",
    conditions: [
      "Jövedelem: Rendszeres, igazolt havi nettó jövedelem (munkabér vagy nyugdíj), amely közvetlenül a bankszámlára érkezik.",
      "Munkaviszony: Minimum 3 hónapos folyamatos, határozatlan idejű munkaviszony (vagy vállalkozók esetén 1 lezárt üzleti év).",
      "Hitelképesség: Aktív BAR lista kizáró. Passzív BAR listával már van lehetőség igénylésre, de a legjobb, ha nincs BAR státusz.",
    ],
  },
  {
    id: "munkashitel",
    name: "Munkáshitel",
    tag: "Kamatmentes kölcsön fiataloknak",
    desc: "Kamatmentes, legfeljebb 4 millió forintos kölcsön fiatal, dolgozó pályakezdőknek — teljes körű ügyintézéssel.",
    conditions: [
      "Életkor: A 17. életévét betöltötte, de a 26. életévét még nem töltötte be.",
      "Összeg és kamat: Legfeljebb 4 millió forint, kamatmentes konstrukció, akár 10 éves futamidővel.",
      "Munkaviszony / TB: Legalább 3 hónap folyamatos TB-jogviszony és rendszeres, igazolt jövedelem.",
      "Egyéb feltételek: Magyarországi lakcím, felsőoktatási hallgatói jogviszony hiánya, negatív KHR-státusz és NAV-tartozás hiánya.",
    ],
  },
];

export const OFFICES = [
  {
    id: "nyirbator",
    city: "Nyírbátor",
    address: "4300 Nyírbátor, Ipari park utca 9.",
    query: "4300 Nyírbátor, Ipari park utca 9.",
  },
  {
    id: "nyiregyhaza",
    city: "Nyíregyháza",
    address: "4400 Nyíregyháza, Dózsa György utca 32-34",
    query: "4400 Nyíregyháza, Dózsa György utca 32-34",
  },
  {
    id: "mateszalka",
    city: "Mátészalka",
    address: "4700 Mátészalka, Alkotmány út 37",
    query: "4700 Mátészalka, Alkotmány út 37",
  },
];

export const mapsUrl = (query) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;

export const TIME_SLOTS = [
  "08:00", "09:00", "10:00", "11:00",
  "13:00", "14:00", "15:00", "16:00",
];

export const MODES = [
  { id: "szemelyes", label: "Személyes", value: "Személyes" },
  { id: "telefonos", label: "Telefonos", value: "Telefonos" },
  { id: "video", label: "Videóhívás", value: "Videóhívás" },
];

export const LOGO_URL =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_dc3356a0-fe67-4e65-9294-818814845cec/artifacts/jbhiiyn6_Saja%CC%81t%20logo%CC%81.png";

// Portrait of the advisor. Replace with the uploaded photo URL when available.
export const PORTRAIT_URL =
  "https://customer-assets-cm19k8pv.emergentagent.net/job_nyirbator-penzugyi/artifacts/alg37fad_photo_2026-07-25_00-03-06.jpg";

// Warm, friendly office interior (replaces the previous skyscraper image).
export const OFFICE_FRIENDLY_IMG =
  "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1200&q=80";
